import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import Helmet from 'react-helmet';
import {
  reduce, each,
} from 'lodash';
import Fa from 'react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import CheckboxCell from './CheckboxCell';

// Import Actions
import {
  updateOrganizationUserRoles,
} from '../../SetupActions';


import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getViewableDimensions } from '../../../App/AppReducer';
import styles from './styles.css';

const allRoles = [
  { key: 'user', label: 'Sales Rep' },
  { key: 'manager', label: 'Sales Manager' },
  { key: 'admin', label: 'Admin' },
];

const allModules = [
  { key: 'buyer_decisions', label: 'Buyer Decisions', group: 'Feedback' },
  { key: 'customer_experience', label: 'Customer Experience', group: 'Feedback' },
  // { key: 'progress_dashboard', label: 'Progress Dashboard', group: 'Feedback' },
  { key: 'dashboard', label: 'Dashboard', group: 'Feedback' },
  { key: 'feedback_request', label: 'Feedback Requests', group: 'Feedback' },
  { key: 'feedback_exclusions', label: 'Excluded', group: 'Feedback' },

  { key: 'leaderboard_leader', label: 'Leader List', group: 'Leaderboards' },
  { key: 'leaderboard_naughty', label: 'Naughty List', group: 'Leaderboards' },
  
  { key: 'workspace', label: 'Workspace' },
  { key: 'forecast', label: 'Forecast' },
  { key: 'outcomes', label: 'Outcomes' },
  { key: 'performance', label: 'Performance' },
  { key: 'pipeline', label: 'Pipeline' },
  { key: 'nominations', label: 'Nominations' },
];

const allAccessTypes = [
  {
    key: 'ALL',
    value: 'ALL',
    label: 'All Data',
    tips: 'Selecting this option will give users of that type access to all data',
  },
  {
    key: 'OWNERSHIP',
    value: 'OWNERSHIP',
    label: 'By Ownership',
    tips: 'Selecting this option for sales reps will restrict their views to their opportunities and accounts. Selecting this option for a sales manager will restrict their views to their opportunities and accounts plus the opportunities and accounts of the sales reps they are managing.',
  },
  {
    key: 'NO_ACCESS',
    value: null,
    label: 'No Access',
    tips: 'Selecting this option will hide that TruVoice Automation module from users of that type',
  },
];

function GroupRowInnerRenderer(props) {
  return (
    <strong>{props.value}</strong>
  );
}

function CustomHeader(props) {
  const { column: { colDef: { colId, cellRendererParams } } } = props;
  let display = (<strong>{props.displayName}</strong>);
  if (cellRendererParams && cellRendererParams.tips) {
    const tooltip = (
      <Tooltip id={`${colId}-description`}>
        {cellRendererParams.tips}
      </Tooltip>
    );
    display = (
      <OverlayTrigger placement="bottom" overlay={tooltip}>
        <strong>{props.displayName} <Fa name="info-circle" className="text-active" /></strong>
      </OverlayTrigger>
    );
  }
  return display;
}

function LabelRenderer(props) {
  const { value, data } = props;
  const prefix = data && data.module && data.module.group ? <span>{data.module.group} <Fa className="text-muted" name="chevron-right" /></span> : null;
  return (
    <span>{prefix} {value}</span>
  );
}
LabelRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    module: PropTypes.shape({
      group: PropTypes.string,
    }),
  }),
};
LabelRenderer.defaultProps = {
  value: null,
  data: null,
};

class UserPermissionPage extends Component {
  constructor() {
    super();
    this.state = {
      updating: false,
      currentUserRole: null,
      currentModule: null,
      currentAccessType: null,
      data: [],
    };
    this.handleCellClicked = this.handleCellClicked.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
  }

  componentWillMount() {
    this.setState({ data: this.populateData(this.props) }, () => {
      if (this.gridApi) {
        this.gridApi.resetRowHeights();
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const currentOrg = this.props.organization || {};
    const nextOrg = nextProps.organization || {};
    if (currentOrg._id !== nextOrg._id) {
      this.setState({ data: this.populateData(nextProps) }, () => {
        if (this.gridApi) {
          this.gridApi.resetRowHeights();
        }
      });
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  populateData(props) {
    const { organization } = props;
    const roleAccessRoles = organization.role_access_rules;
    return reduce(allRoles, (rows, userRole) => {
      each(allModules, (module) => {
        const row = {
          id: `${userRole.key}-${module.key}`,
          userRole,
          module,
        };
        each(allAccessTypes, (allAccessType) => {
          let val = false;
          if (roleAccessRoles[userRole.key] && roleAccessRoles[userRole.key][module.key] !== undefined && roleAccessRoles[userRole.key][module.key] === allAccessType.value) {
            val = true;
          }
          row[allAccessType.key] = val;
        });

        rows.push(row);
      });
      return rows;
    }, []);
  }


  handleCellClicked(params) {
    const { updating } = this.state;
    const { data, column: { colId } } = params;
    if (!updating && data && data.userRole && data.userRole.key === 'user') {
      const roleAccessRoles = { [data.userRole.key]: { [data.module.key]: colId === 'NO_ACCESS' ? null : colId } };
      this.setState({ updating: true, currentUserRole: data.userRole.key, currentModule: data.module.key, currentAccessType: colId });
      this.props.dispatch(updateOrganizationUserRoles(roleAccessRoles))
        .then(
          () => {
            this.setState({
              updating: false,
              currentUserRole: null,
              currentModule: null,
              currentAccessType: null,
              data: this.populateData(this.props),
            }, () => {
              if (this.gridApi) {
                this.gridApi.resetRowHeights();
              }
            });
          },
          () => {
            this.setState({
              updating: false, currentUserRole: null, currentModule: null, currentAccessType: null,
            });
          },
        );
    }
  }

  renderTable() {
    const {
      updating, currentUserRole, currentModule,
      currentAccessType, data,
    } = this.state;
    const { viewableDimensions } = this.props;
    const columnDefs = [
      {
        headerName: 'Role',
        field: 'userRole.label',
        hide: true,
        rowGroupIndex: 0,
      },
      {
        headerName: 'Module',
        field: 'module.label',
        width: 656,
        cellClass: styles.labelCell,
        cellRenderer: LabelRenderer,
        pinned: 'left',
      },
      {
        headerName: 'Module and Data Access',
        children: (reduce(allAccessTypes, (items, allAccessType) => {
          items.push({
            headerName: allAccessType.label,
            field: allAccessType.key,
            colId: allAccessType.key,
            width: 160,
            cellRendererParams: {
              tips: allAccessType.tips,
              updating,
              currentUserRole,
              currentModule,
              currentAccessType,
            },
            cellRenderer: CheckboxCell,
            onCellClicked: this.handleCellClicked,
          });
          return items;
        }, [])),
      },
    ];

    const { height } = viewableDimensions;
    return (
      <div className={`ag-theme-alpine ${styles.table}`} style={{ height, width: '100%' }} >
        <AgGridReact
          reactNext
          columnDefs={columnDefs}
          rowData={data}
          animateRows
          suppressMovableColumns
          suppressRowClickSelection
          onGridReady={this.onGridReady}
          groupUseEntireRow
          groupDisplayType="groupRows"
          groupRowRendererParams={{
            innerRenderer: GroupRowInnerRenderer,
            suppressCount: true,
          }}
          groupDefaultExpanded={-1}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        <Helmet title="Module and Data Access" />
        <div className="container">
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
    viewableDimensions: getViewableDimensions(state),
  };
}

UserPermissionPage.propTypes = {
  organization: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
  viewableDimensions: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

UserPermissionPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(UserPermissionPage);
